module.exports = __webpack_public_path__ + "cd91a79f1a2d6e90a9844e0d4bcf7258.png";